import { Platform } from "react-native";
import MovexGeo from "@movexgeo/react-native-movex";
import { movexPublishableKey, trackingEnabled } from "@config";

const initMovex = async (userId) => {
  if (Platform.OS !== "android") return;
  if (!trackingEnabled) return;
  if (!movexPublishableKey) return;
  try {
    await MovexGeo.initialize(movexPublishableKey);
    if (userId) await MovexGeo.setUserId(String(userId));
    await MovexGeo.startTracking("efficient");
  } catch {
    // non-fatal — tracking will remain inactive
  }
};

export default initMovex;
